import { ClientType, ClientConfig } from "../types/form";

export const CLIENT_CONFIGS: Record<ClientType, ClientConfig> = {
  Onboarding: {
    name: "Onboarding",
    description: "Quick setup for new users with essential information only",
    visibleSteps: ["TemplateSelection", "AboutMe", "Success"],
    requiredSteps: ["TemplateSelection", "AboutMe"],
    maxSteps: 2,
  },
  KlinTeam: {
    name: "KlinTeam",
    description: "KlinTeam profile with all available features",
    visibleSteps: [
      "TemplateSelection",
      "AboutMe",
      "Success",
    ],
    requiredSteps: ["TemplateSelection", "AboutMe"],
    maxSteps: 2,
  },
  Professional: {
    name: "Professional",
    description:
      "Standard professional profile with social media and customization",
    visibleSteps: [
      "TemplateSelection",
      "Customization",
      "AboutMe",
      "Success",
    ],
    requiredSteps: [
      "TemplateSelection",
      "AboutMe",
    ],
    maxSteps: 3,
  },
  Enterprise: {
    name: "Enterprise",
    description:
      "Full-featured profile with all options including reviews and advanced customization",
    visibleSteps: [
      "TemplateSelection",
      "Customization",
      "AboutMe",
      "Reviews",
      "Success",
    ],
    requiredSteps: [
      "TemplateSelection",
      "AboutMe",
    ],
    maxSteps: 4,
  },
  Default: {
    name: "Default",
    description: "Standard profile with all available features",
    visibleSteps: [
      "TemplateSelection",
      "Customization",
      "AboutMe",
      "Reviews",
      "Success",
    ],
    requiredSteps: [
      "TemplateSelection",
      "AboutMe",
    ],
    maxSteps: 4,
  },
};

export const getClientConfig = (clientType: ClientType): ClientConfig => {
  return CLIENT_CONFIGS[clientType] || CLIENT_CONFIGS.Default;
};

export const isStepVisible = (
  clientType: ClientType,
  stepName: string,
): boolean => {
  const config = getClientConfig(clientType);
  return config.visibleSteps.includes(stepName);
};

export const getVisibleStepsForClient = (clientType: ClientType): string[] => {
  const config = getClientConfig(clientType);
  return config.visibleSteps;
};

export const getMaxStepsForClient = (clientType: ClientType): number => {
  const config = getClientConfig(clientType);
  return config.maxSteps;
};

export const isValidClientType = (
  clientType: string,
): clientType is ClientType => {
  return Object.keys(CLIENT_CONFIGS).includes(clientType);
};
